import { action } from 'satcheljs';
import { addDatapointConfig } from 'owa-analytics-actions';
import EmailReminderEntrySource from '../store/schema/EmailReminderEntrySource';

export const showEmailReminderDialog = action(
    'showEmailReminderDialog',
    (entrySource: EmailReminderEntrySource) =>
        addDatapointConfig(
            {
                name: 'ShowEmailReminderDialog',
                customData: {
                    entrySource: entrySource,
                },
            },
            {}
        )
);

export const hideEmailReminderDialog = action('hideEmailReminderDialog');

export const setShowDialog = action('setShowDialog', (shouldShow: boolean) => ({
    shouldShow,
}));
